export enum TrackingEvent {
  SelectMetric = `[mp-query-builder] Select Metric`,

  SelectMetricCategory = `[mp-query-builder] Select Metric Category`,

  OpenMetricsDropDown = `[mp-query-builder] Opened Metrics Dropdown`,
  OpenCreateInlineMetrics = `[mp-query-builder] Opened Create Inline Metrics`,
  OpenInlineCohortsModal = `[mp-query-builder] Opened Inline Cohorts Modal`,
  OpenCustomEventsModal = `[mp-query-builder] Opened Custom Events Modal`,

  CreateInlineCohort = `[mp-query-builder] Created Inline Cohort`,
  EditInlineCohorts = `[mp-query-builder] Edit Inline Cohort`,
  SaveInlineCohorts = `[mp-query-builder] Save Inline Cohort`,
}

export const enum TrackProperties {
  SelectedCategory = `Selected category`,
  SelectedMenuType = `Selected item type`,
  SelectedMetricName = `Selected metric name`,
  SelectedMetricValue = `Selected metric value`,

  IsRecentlyViewed = `is recently viewed`,
  SearchFilter = `Search - filter`,
  SearchLabelMatch = `Search - label match`,
  SearchSubLabelMatch = `Search - sublabel match`,
  SearchCustomMatch = `Search - custom match`,
  ElapsedTime = `Elapsed time (ms) since menu opened`,

  PropertyType = `property type`,

  IsCustomEvent = `is custom event`,
  IsAutoTrackEvent = `is autotrack event`,
  IsHiddenEntity = `is hidden entity`,
  MetaDataSearchEnabled = `Metadata Search Enabled`,
  IsVerified = `Is Verified`,
}
